


export class RuleValidationResult {

    private _errors = new Set<string>();
    public isValid?: boolean = true;

    get errors(): string[] {
        return Array.from(this._errors);
    }

    public addError(error: string): void {
        this.isValid = false;
        this._errors.add(error);
    }

}